import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
const points = ["Llegás a mitad de mes y aparece el clásico: '¿y ahora?'", 'Gastos chicos repetidos que parecen nada… hasta que suman una fortuna', 'Te da culpa mirar números, entonces lo pateás', "Intentás 'controlarte' unos días y después abandonás", 'La tarjeta te marca el ritmo (y no al revés)', 'Imprevistos que te rompen todo porque no había margen', 'Cada mes empezás de cero, con ansiedad y cansancio'];
export function PainPoints() {
  return <section className="py-16 bg-[#FFFFFF]" data-id="element-164">
      <div className="container mx-auto px-4" data-id="element-165">
        <div className="max-w-3xl mx-auto" data-id="element-166">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-left mb-8" data-id="element-167">
            <h2 className="text-3xl md:text-4xl font-black text-black uppercase tracking-tight mb-4" data-id="element-168">
              ¿Cuántos meses más vas a pasar así?
            </h2>
            <p className="text-sm text-slate-500" data-id="element-169">
              Vivís en Argentina. Laburás. Hacés malabares. Pero nadie te enseñó
              un sistema simple para que el mes no te arrastre.
              <strong className="text-black" data-id="element-170">
                {' '}
                No es falta de ganas. Es falta de un método.
              </strong>
            </p>
          </motion.div>

          <div className="rounded-2xl p-6 md:p-8 border border-red-200 mb-8 bg-[#9F0404DF]" data-id="element-171">
            <ul className="space-y-4" data-id="element-172">
              {points.map((point, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.05
            }} className="flex items-start gap-3" data-id="element-173">
                  <XCircle className="text-red-500 shrink-0 mt-0.5" size={20} data-id="element-174" />
                  <span className="text-black font-medium text-sm" data-id="element-175">
                    {point}
                  </span>
                </motion.li>)}
            </ul>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-left" data-id="element-176">
            <h3 className="text-xl md:text-2xl font-black text-blue-600 uppercase" data-id="element-177">
              ¿Y si este fuera el último mes que vivís así?
            </h3>
          </motion.div>
        </div>
      </div>
    </section>;
}